import { NavigationGuard } from "vue-router";
import { auth } from "@/utils/LtkAuth0";
import Authentication from ".";

const $authentication = new Authentication();

/**
 * Implicit On navigation guard requires the next route to specify
 * that it does not require auth before checking authentication status
 * of the user.
 */
const redirectRoute = async (config: any) => {
  const {
    isAuthenticated,
    isLambdaAuthorized,
    accessToken,
    idTokenClaims,
    to,
    next,
  } = config;
  if (!isLambdaAuthorized) {
    await $authentication.lambdaAuthorize(accessToken, idTokenClaims, "login");
  }
  if (!isAuthenticated) {
    return next({ path: "/login" });
  } else if (isAuthenticated && to.name === "Login") {
    return next({ path: "/logged-in" });
  } else {
    return next();
  }
};

const navigationGuard: NavigationGuard = async (to, from, next) => {
  const openID = $authentication.openID;
  if (openID) {
    $authentication.setOpenID(openID);
  }
  const fullPath = to.fullPath;
  if (to.meta && to.meta.title) {
    window.document.title = to.meta.title as string;
  }

  if (!to.meta.requiresAuth && to.name !== "Login") {
    if (!to.meta.requiresAuth) {
      if (to.fullPath === "/" || !to.name) {
        return next({ path: "login" });
      }
      return next();
    }
    return next();
  }

  try {
    const accessToken = (await auth.getAccessToken()) || "";
    const idTokenClaims = (await auth.getIdTokenClaims())?.__raw;
    const isAuthenticated = await auth.isAuthenticated();
    // if (window.navigator.userAgent.includes("KAKAOTALK")) {
    if (openID) {
      const isLambdaAuthorized = await $authentication.checkLoggedIn(
        openID,
        accessToken
      );

      return redirectRoute({
        isAuthenticated,
        accessToken,
        idTokenClaims,
        isLambdaAuthorized,
        to,
        next,
      });
    } else {
      window.alert(
        "알 수 없는 오류가 발생했습니다. 다시 시도하거나 계정 담당자에게 연락하세요."
      );
      return next({ path: "/login" });
    }
    // } else {
    //   window.alert("해당 페이지는 카카오톡에서 다시 접속 부탁 드립니다. ");
    // }
  } catch (error) {
    if (
      error instanceof Error &&
      error.message.toLowerCase() === "login required"
    ) {
      await auth.login({
        options: {
          appState: {
            target: `${fullPath}`,
          },
        },
        next: `${fullPath}`,
      });
    }
  }
  return next();
};

export default navigationGuard;
